import i18next from 'i18next';
import { toast } from 'sonner';
import { useBiaStore } from '../../store/bia.store.js';

export class RpoCalculationIntegration {
    constructor(service) {
        this.service = service;
    }

    async fetchItems(params = {}) {
        const store = useBiaStore.getState();
        try {
            const response = await this.service.getAll(params);
            return {
                success: true,
                data: response.data,
                pagination: response.pagination
            };
        } catch (error) {
            toast.error(error.message || i18next.t('integrationToasts:anErrorOccurred', { defaultValue: 'An error occurred' }));
            return { success: false, error: error.message };
        }
    }

    async getItemById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async createItem(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:recordCreated', { defaultValue: 'Record created' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async updateItem(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:recordUpdated', { defaultValue: 'Record updated' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async deleteItem(id) {
        try {
            const response = await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:recordDeleted', { defaultValue: 'Record deleted' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async deleteItems(ids) {
        try {
            const response = await this.service.batchDelete(ids);
            toast.success(i18next.t('integrationToasts:recordsDeleted', { defaultValue: 'Records deleted' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }
}
